import React, { useEffect } from 'react'
import { FaHome, FaBookOpen, FaUserCheck, FaMoneyCheck } from 'react-icons/fa'
import { FaMessage, FaNoteSticky, FaUsers } from 'react-icons/fa6'
import { MdQuiz, MdLeaderboard } from 'react-icons/md'
import { IoLibrarySharp, IoAnalyticsSharp } from 'react-icons/io5'
import { BiChevronRight, BiRadioCircleMarked } from "react-icons/bi";
import { AiOutlineHome } from "react-icons/ai";
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { PiCertificateFill } from 'react-icons/pi'

export default function SIDEBAR() {

    const location = useLocation()
    const navigate = useNavigate()

    const msidebar = () => {

        const userRole = JSON.parse(localStorage.getItem('user_data'));
        const role = userRole && userRole.vrole_name
        // console.log("role", role)

        return (
            <PerfectScrollbar>

                <div className="accordion accordion-flush" id="accordionFlushExample" style={{ borderRadius: '0rem' }}>

                    <div className="accordion-item" style={{ border: 'none' }}>
                        <h2 className="accordion-header" data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#dashboard" aria-expanded="false" aria-controls="dashboard"
                                onClick={() => navigate(role === "Learner" ? '/learner-dashboard' : '/dashboard')}
                            >
                                <FaHome size={20} className='me-3' />
                                Dashboard
                            </button>
                        </h2>
                        <div id="dashboard" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                            <div className="accordion-body acc_body">

                            </div>
                        </div>
                    </div>

                    {role === "Admin" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#masters" aria-expanded="false" aria-controls="masters">
                                    <MdLeaderboard size={20} className='me-3' />
                                    Masters
                                </button>
                            </h2>
                            <div id="masters" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body acc_body">
                                    <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                        <NavLink to='/department'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/department' ? 'custom_active' : ''}>Department</li></NavLink>
                                        <NavLink to='/add_group'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_group' ? 'custom_active' : ''}>Add Group</li></NavLink>
                                        <NavLink to='/group_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/group_list' ? 'custom_active' : ''}>Group List</li></NavLink>
                                        <NavLink to='/venue'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/venue' ? 'custom_active' : ''}>Venue</li></NavLink>
                                        <NavLink to='/announcement'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/announcement' ? 'custom_active' : ''}>Announcement</li></NavLink>
                                        <NavLink to='/poll'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/poll' ? 'custom_active' : ''}>Poll</li></NavLink>
                                        <NavLink to='/user_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/user_list' ? 'custom_active' : ''}>User List</li></NavLink>
                                        <NavLink to='/quiz_marks'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/quiz_marks' ? 'custom_active' : ''}>Quiz Marks</li></NavLink>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        : ''
                    }


                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#course" aria-expanded="false" aria-controls="course">
                                <FaBookOpen size={20} className='me-3' />
                                Module Management
                            </button>
                        </h2>
                        <div id="course" className={role === "Learner" ? "accordion-collapse collapse show" : "accordion-collapse collapse"} data-bs-parent="#accordionFlushExample">
                            <div className="accordion-body acc_body">
                                <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                    {role === "Admin" ? <NavLink to='/add_course'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_course' ? 'custom_active' : ''}>Add Learning Module</li></NavLink> : ""}

                                    <NavLink to={role === "Learner" ? '/learner_course_list' : '/course_list'}> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/learner_course_list' || location.pathname === '/course_list' ? 'custom_active' : ''}>Learning Module List</li></NavLink>

                                    {role === "Admin" || role === "Instructor" ? <NavLink to='/add_training'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_training' ? 'custom_active' : ''}>Add Session </li></NavLink> : ""}

                                    <NavLink to='/training_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/training_list' ? 'custom_active' : ''}>Session List</li></NavLink>

                                    {role === "Admin" || role === "Instructor" ? <NavLink to='/add_learning_track'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_learning_track' ? 'custom_active' : ''}>Add Learning Track</li></NavLink> : ""}
                                    {role === "Admin" || role === "Instructor" ? <NavLink to='/learning_track'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/learning_track' ? 'custom_active' : ''}>Learning Track</li></NavLink> : ""}
                                    {role === "Learner" ? <NavLink to='/add_external_training'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_external_training' ? 'custom_active addexternal-step' : 'addexternal-step'}>Add External Training</li></NavLink> : ""}
                                    {role === "Admin" || role === "Learner" ? <NavLink to='/external_training_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/external_training_list' ? 'custom_active externallist-step' : 'externallist-step'}>External Training</li></NavLink> : ""}
                                    {role === "Admin" ? <NavLink to='/enroll_course_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/enroll_course_list' ? 'custom_active' : ''}>Enrollment</li></NavLink> : ""}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {role === "Admin" || role === "Instructor" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#quiz" aria-expanded="false" aria-controls="quiz">
                                    <MdQuiz size={20} className='me-3' />
                                    Quiz
                                </button>
                            </h2>
                            <div id="quiz" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body acc_body">
                                    <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                        <NavLink to='/add_question'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_question' ? 'custom_active' : ''}>Add Question</li></NavLink>
                                        <NavLink to='/question_list'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/question_list' ? 'custom_active' : ''}>Question List</li></NavLink>
                                        <NavLink to='/create_quiz'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/create_quiz' ? 'custom_active' : ''}>Create Quiz</li></NavLink>
                                        <NavLink to='/quiz_list'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/quiz_list' ? 'custom_active' : ''}>Quiz List</li></NavLink>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    {role === "Admin" || role === "Instructor" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header" data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#file_lib" aria-expanded="false" aria-controls="file_lib"
                                    onClick={() => navigate('/library')}
                                >
                                    <IoLibrarySharp size={20} className='me-3' />
                                    File Library
                                </button>
                            </h2>
                            <div id="file_lib" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                                <div className="accordion-body acc_body">

                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    <div className="accordion-item">
                        <h2 className="accordion-header" data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#messages" aria-expanded="false" aria-controls="messages"
                                onClick={() => navigate('/messages')}
                            >
                                <FaMessage size={20} className='me-3' />
                                <span className='message-step'>
                                    Messages
                                </span>
                            </button>
                        </h2>
                        <div id="messages" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                            <div className="accordion-body acc_body">

                            </div>
                        </div>
                    </div>

                    {role === "Admin" || role === "Instructor" ?

                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#report" aria-expanded="false" aria-controls="report"
                                >
                                    <IoAnalyticsSharp size={20} className='me-3' />
                                    Reports
                                </button>
                            </h2>
                            <div id="report" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body acc_body">
                                    <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                        <NavLink to='/report'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/report' ? 'custom_active' : ''}>Report Management</li></NavLink>
                                        {/* <NavLink to='/audit-trail'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>Audit Trail</li></NavLink> */}
                                        <NavLink to='/audit-report'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/audit-report' ? 'custom_active' : ''}>Audit Report</li></NavLink>
                                        {/* <NavLink to='/department_report'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>Department Reports</li></NavLink>
                                        <NavLink to='/report'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''}>Reports</li></NavLink> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    {role === "Learner" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#certificates" aria-expanded="false" aria-controls="certificates"
                                    onClick={() => navigate('/certificates')}
                                >
                                    <PiCertificateFill size={20} className='me-3' />
                                    <span className='certificate-step'>
                                        Certificates
                                    </span>
                                </button>
                            </h2>
                            <div id="certificates" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                                <div className="accordion-body acc_body">

                                </div>
                            </div>
                        </div>
                        : ""
                    }

                    {role === "Admin" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#template" aria-expanded="false" aria-controls="template">
                                    <PiCertificateFill size={20} className='me-3' />
                                    Certificate
                                </button>
                            </h2>
                            <div id="template" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body acc_body">
                                    <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                        <NavLink to='/add_certificate_template'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/add_certificate_template' ? 'custom_active' : ''}>Add Template</li></NavLink>
                                        <NavLink to='/certificate_template_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/certificate_template_list' ? 'custom_active' : ''}>Template List</li></NavLink>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    {role !== "Learner" ?
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#notes" aria-expanded="false" aria-controls="notes"
                                    onClick={() => navigate('/feedback')}
                                >
                                    <FaNoteSticky size={20} className='me-3' />
                                    Feedback
                                </button>
                            </h2>
                            <div id="notes" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                                <div className="accordion-body acc_body">

                                </div>
                            </div>
                        </div>
                        : ""
                    }

                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#hr" aria-expanded="false" aria-controls="hr">
                                <FaUsers size={20} className='me-3' />
                                Hr
                            </button>
                        </h2>
                        <div id="hr" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                            <div className="accordion-body acc_body">
                                <ul className='sub_menu' style={{ marginBottom: '0rem' }}>
                                    <NavLink to='/attendance_list'> <li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/attendance_list' ? 'custom_active' : ''}>Attendance & Leaves</li></NavLink>
                                    <NavLink to='/salary_list'><li data-bs-dismiss={mobileScreen ? "offcanvas" : ''} className={location.pathname === '/salary_list' ? 'custom_active' : ''}>Salary</li></NavLink>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#attendance" aria-expanded="false" aria-controls="attendance"
                                onClick={() => navigate('/attendance_list')}
                            >
                                <FaUserCheck size={20} className='me-3' />
                                Attendance
                            </button>
                        </h2>
                        <div id="attendance" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                            <div className="accordion-body acc_body">

                            </div>
                        </div>
                    </div>

                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed acc_btn" type="button" data-bs-toggle="collapse" data-bs-target="#salary" aria-expanded="false" aria-controls="salary"
                                onClick={() => navigate('/salary_list')}
                            >
                                <FaMoneyCheck size={20} className='me-3' />
                                Salary
                            </button>
                        </h2>
                        <div id="salary" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ display: 'none' }}>
                            <div className="accordion-body acc_body">

                            </div>
                        </div>
                    </div> */}

                </div>

            </PerfectScrollbar>
        )
    }

    let mobileScreen = window.screen.width <= 992;

    return (
        <>
            {mobileScreen ?
                (<div className="offcanvas offcanvas-start offCanvas_sidebar " data-bs-scroll="true" tabIndex="-1" id="sideBar" aria-labelledby="offcanvasWithBothOptionsLabel" >{msidebar()}</div>)
                :
                (<div className='sidebar'>{msidebar()} </div >)}
        </>
    )
}
